module.exports = __webpack_public_path__ + "img/pixar-logo.83c40964.png";